import React from 'react';
import { connect } from 'react-redux'
import { Utils } from '../../util/utils';

class ProductDetailColor extends React.PureComponent {
    /**handle arrow key event */
    onColorBtnKeyDown = (e,btnId,productId) => {
       
            //left = 37,down = 40 ===prev, up = 38; right = 39 ==next; 
        if (e.keyCode === 38 || e.keyCode ===39) {
            if(document.getElementById(btnId) &&  document.getElementById(btnId).nextElementSibling){
                    document.getElementById(btnId).nextElementSibling.focus();   
            }
    
        }
        else if (e.keyCode === 37|| e.keyCode ===40) {
                if(document.getElementById(btnId) &&  document.getElementById(btnId).previousElementSibling){
                    document.getElementById(btnId).previousElementSibling.focus();
                   
                }

        }
        if(document.activeElement && document.activeElement.id){
            let currentElementId = document.activeElement.id;
         let currentProductId = currentElementId.split('_');
         if(currentProductId && currentProductId.length && currentProductId[2]){
            this.props.colorSelectionValue(currentProductId[2]);
         }
        

        }
    
        
       };
    render(){
            let colorList=[];
            let selectedColor='';
            let styleColor=[];
            let lytColor=[];
            let darkColor=[];
            let textColor=''
            let color;    
            let prodcolor  ;
            let nonWorkingColor = "" ;
              
            this.props.itemValue.map((itemValue, index) => {
                if(itemValue.color){
                prodcolor=itemValue.color.replace(/\s/g, '')
                }
                else{
                 prodcolor=itemValue.color
                }
                if(prodcolor && prodcolor != "" && prodcolor.toLowerCase() =="gray/teal"){
                    nonWorkingColor = "whitesmoke"
                  }            
                if(this.props.itemValue.length===1){
                    if (Utils.isNotNull(itemValue.color)) {
                         color=itemValue.color
                        lytColor=['Chalk','Charcoal','Lilac','Slate','White']
                        darkColor=['Black','Blue','Gray','Grey','Silver']
                        lytColor.map((colorLyt,index)=>{
                            if(colorLyt===color){
                                textColor="text-black"
                            }
                            return "";
                        })
                        darkColor.map((colorDark,index)=>{
                            if(colorDark===color){
                                textColor="text-white"
                            }
                            return "";
                        })
                    selectedColor=("bg-sku830084-sku830084 active active-check mediumcpicker bg-" +prodcolor.toLowerCase()+ " "+textColor)
                    styleColor=itemValue.color;
                }}
                else if(this.props.itemValue.length>1){
                    if (Utils.isNotNull(itemValue.color)) {
                         color=itemValue.color
                        lytColor=['Chalk','Charcoal','Lilac','Slate','White']
                        darkColor=['Black','Blue','Gray','Grey','Silver']
                        lytColor.map((colorLyt,index)=>{
                            if(colorLyt===color){
                                textColor="text-black"
                            }
                            return "";
                        })
                        darkColor.map((colorDark,index)=>{
                            if(colorDark===color){
                                textColor="text-white"
                            }
                            return "";
                        })
                    selectedColor=(this.props.selectedValue.productId===itemValue.productId ? ("bg-sku830084-sku830084 active active-check mediumcpicker bg-" +prodcolor.toLowerCase()+ " "+textColor) :("bg-sku830084-sku830084 mediumcpicker bg-" +prodcolor.toLowerCase()+ " "+textColor))  
                    styleColor=itemValue.color;
                 }}
                 if (Utils.isNotNull(selectedColor) && selectedColor!=="") {
                colorList.push(
                    // <span>
                    // <li className={selectedColor} id="prod670040_sku830084_sku830084" style={{ backgroundColor : styleColor}} title={styleColor} onClick={(e) => { this.props.colorSelectionValue(itemValue.productId)}}></li> &nbsp;&nbsp;&nbsp;
                       <li aria-checked={(this.props.selectedValue.productId === itemValue.productId) ? true: false} tabindex={(this.props.selectedValue.productId === itemValue.productId) ?'0': '-1'}  role="radio" className={selectedColor} id ={'prod670040_sku830084_'+itemValue.productId} onKeyDown={(e) => { this.onColorBtnKeyDown(e,'prod670040_sku830084_'+itemValue.productId,itemValue.productId)}}  style={{ backgroundColor: nonWorkingColor!=""? nonWorkingColor: styleColor }} title={styleColor}  aria-label={(this.props.selectedValue.productId === itemValue.productId) ? styleColor + ' Color Selected': styleColor + ' Color'} onClick={(e) => { this.props.colorSelectionValue(itemValue.productId)}} ></li> 
                       //&nbsp;&nbsp;&nbsp;
                    // </span>
                 )}
                nonWorkingColor = ""
                 return "";
            }) 
        return (
            <React.Fragment>
                { (colorList && colorList.length > 0) ? <ul className="no-bullet" data-product-color="" role="radiogroup" aria-label={this.props.itemValue[0].name}>
                {colorList}
                </ul> : ""}
            </React.Fragment>
        );
    }
}

export default (connect()(ProductDetailColor));
